module.exports = __webpack_public_path__ + "static/media/agile_git_mamp.49cba46a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skills/agile_git_mamp.png
// module id = 74
// module chunks = 0